/**
 * Contract of `POST api/Legislation/resolve-summaries`: the fields a list shows
 * for a legislation document, without the document itself (no html). Field
 * names and values match the same fields on `Legislation`.
 */

/** The most items one resolve-summaries request may carry; the API 400s above it. */
export const LEGISLATION_SUMMARY_BATCH_LIMIT = 100;

export interface LegislationSummaryRequestItem {
  externalId: string;
  /** The stored datasource value, e.g. "Retsinformation" (see `getDbValue`). */
  datasource: string;
}

export interface LegislationSummary {
  internalId: string;
  externalId: string;
  title: string;
  datasource: string;
  /** The raw silver metadata JSON, as on `Legislation.metadataObject`. */
  metadataObject?: string | null;
  publishedOn?: string | null;
  isCurrent?: boolean | null;
}

/** One requested item, echoed back; `legislation` is null when it has no latest version. */
export interface ResolvedLegislationSummary {
  externalId: string;
  datasource: string;
  legislation: LegislationSummary | null;
}
